import { TechnicalSkillsList } from "./components/technicalSkillsList";
import { FormComponent } from "./components/formModelOne";
import React, { Component } from "react";
import { Button, Form, Modal } from "antd";
import { connect } from "react-redux";
import uuid from "uuid/v4";
import * as loginActions from "../../actions";
import "./step12.css";

class StepTwelve extends Component {
  constructor(props) {
    super(props);

    this.state = { visible: false, loading: false, showOther: false };
  }

  showModal = () => {
    this.props.modelFromStep(true, false, 10);
  };

  handleCancel = () => {
    this.props.modelFromStep(false, false, 10);
  };

  editSkillHandler = index => e => {
    this.props.modelFromStep(true, false, 10, index);
  };

  deleteProjectHandler = (itemToDelete) => {
    this.props.deleteItem(
      "achievement",
      itemToDelete
    );
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      }
    };

    let { achievement } = this.props.profile;
    const { showOther } = this.state;
    if (typeof achievement == "undefined") {
      achievement = [];
    }

    const { form } = this.props;
    const { getFieldDecorator, validateFields } = form;
    const isEdit = this.props.itemIndex !== null;
    const onValidateForm = itemData => e => {
      e.preventDefault();
      validateFields((err, values) => {
        if (!err) {
          if (itemData) {
            values.achievementID = itemData.achievementID;
          } else {
            values.achievementID = uuid();
          }
          // 
          // 
          values.achievementDate = values.achievementDate.format(
            "MMMM Do YYYY"
          );
          this.props.stepThreeSubmit(
            values,
            "achievement",
            "achievementID"
          );
        }
      });
    };

    // 

    return (
      <>
        <Modal
          visible={this.props.visible.visible}
          title={`${
            isEdit ? "Update honors / awards / achievements" : "Add honors / awards / achievements"
          }`}
          onCancel={this.handleCancel}
          destroyOnClose
          footer={[
            <Button
              key="submit"
              type="primary"
              loading={this.props.visible.loading}
              onClick={onValidateForm(
                this.props.itemIndex !== null
                  ? achievement[this.props.itemIndex]
                  : null
              )}
            >
              {`${isEdit ? "Update Achievement" : "Add Achievement"}`}
            </Button>
          ]}
        >
          <FormComponent
            technicalSkills={achievement}
            formItemLayout={formItemLayout}
            getFieldDecorator={getFieldDecorator}
            showOther={showOther}
            onChange={this.onChange}
            onSearch={this.onSearch}
            itemData={
              this.props.itemIndex !== null
                ? achievement[this.props.itemIndex]
                : null
            }
          />
        </Modal>
        <h2 className="steponeHeading">Achievements </h2>
        <p className="steponeDisc">
          List all your relevant Achievements / Honors / Awards
        </p>

        <TechnicalSkillsList
          technicalSkills={achievement}
          showModal={this.showModal}
          editSkill={this.editSkillHandler}
          deleteItem={this.deleteProjectHandler}
          userID = {this.props.auth}
          showAddNew={this.props.showAddNew ? this.props.showAddNew : true}
        />
{ this.props.showDiscription ? <></> : <>    <p style={{ marginTop: 11, marginBottom: 21 }}>
          *{" "}
          <b style={{ fontWeight: 500 }}>if you do not have any achievements / honors / awards to add</b>
          , you may skip this step and press next.{" "}
        </p>

        <Button
          type="primary"
          onClick={() => {
            this.props.goToNextStep(10);
          }}
        >
          Next
        </Button> </> }
        
      </>
    );
  }
}

const mapStateToProps = state => {
  // 
  // 
  return {
    auth: state.firebase.auth,
    step: state.auth.step,
    visible: state.auth,
    profile: state.firebase.profile,
    itemIndex: state.auth.itemIndex
  };
};

const mapDispachToProps = (dispatch, props) => ({
  stepThreeSubmit: (formValue, categary, arrayField, itemIndex = null) => {
    dispatch(
      loginActions.stepWithSkillsSubmit(
        formValue,
        props.history,
        categary,
        10,
        arrayField,
      )
    );
  },
  modelFromStep: (visible, loading, step, itemIndex = null) => {
    dispatch(loginActions.modelFromStep(visible, loading, step, itemIndex));
  },

  goToNextStep: step => {
    dispatch(loginActions.goToStep(step));
  },
  deleteItem: (category,itemToDelete) => {
    dispatch(loginActions.deleteItem( category,itemToDelete));
  }
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(Form.create()(StepTwelve));
